import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import NavSideBarContext from '../contexts/NavSideBarContext';
import CurrentUserContext from '../contexts/CurrentUserContext';
import { UIVersionContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

export const Layout = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const OPENED_NAV_WIDTH = 227;
export const CLOSED_NAV_WIDTH = 47;

export const ScreenWrapperElement = styled.div<{
  isNavOpen: boolean;
  isScrollable?: boolean;
  isFullWidth?: boolean;
}>`
  height: 100%;
  width: calc(
    100% -
      ${(props) =>
        props.isFullWidth
          ? '0px'
          : props.isNavOpen
            ? `${OPENED_NAV_WIDTH}px`
            : `${CLOSED_NAV_WIDTH}px`}
  );
  background-color: var(--color-bg-primary);
  ${(props) => (props.isScrollable ? `overflow-y: auto;` : '')}
`;

export const ScreenWrapper = ({
  children,
  isScrollable,
  testId,
  isFullWidth,
}: {
  children: JSX.Element | (JSX.Element | false)[];
  isScrollable?: boolean;
  testId?: string;
  isFullWidth?: boolean;
}) => {
  const { isV3 } = useContext(UIVersionContext);
  const { isOpen } = useContext(NavSideBarContext);
  const { isWallboardUser } = useContext(CurrentUserContext);

  const isWallBoardPreview = window.location.href
    .toLowerCase()
    .includes('wallboard');
  const isNavOpen = useMemo(() => {
    if (isWallboardUser || isWallBoardPreview) {
      return false;
    }

    return isOpen;
  }, [isOpen, isWallBoardPreview, isWallboardUser]);

  return (
    <ScreenWrapperElement
      isNavOpen={isNavOpen}
      isScrollable={isScrollable}
      data-testid={testId}
      isFullWidth={isFullWidth || isWallBoardPreview || isV3}
    >
      {children}
    </ScreenWrapperElement>
  );
};
